var _this = this;
import * as tslib_1 from "tslib";
import { getUserConfiguration } from 'owa-session-store';
import { updateTimeZoneOffsets } from 'owa-datetime-store';
import { getSupportedFallbackForLocale, setLocale } from 'owa-strings';
import { setRTL } from '@uifabric/utilities';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import getNewTimeZoneOffsets from '../services/getNewTimeZoneOffsets';
import loadTimeZoneOptions from '../orchestration/loadTimeZoneOptions';
import setMailboxRegionalConfiguration from '../services/setMailboxRegionalConfiguration';
import getRegionalOptions from '../data/store/store';
var getRegionalOptionsServiceRequests = function (languageHasChanged, timeZoneHasChanged) {
    var optionState = getRegionalOptions();
    var _a = getUserConfiguration(), UserOptions = _a.UserOptions, SessionSettings = _a.SessionSettings;
    // Make service request
    var setMailboxRegionalConfigurationPromise = setMailboxRegionalConfiguration(SessionSettings.UserCulture, optionState.shouldRenameDefaultFolders, UserOptions.DateFormat, UserOptions.TimeFormat, UserOptions.TimeZone);
    var promises = [setMailboxRegionalConfigurationPromise];
    // VSO:14100 - Rename the default folders, without pulling in mail code.
    if (languageHasChanged) {
        promises.push(setMailboxRegionalConfigurationPromise.then(loadTimeZoneOptions));
        if (isControlFeatureEnabled('fwk-localeHotReload')) {
            var language_1 = getSupportedFallbackForLocale(optionState.selectedLocale);
            promises.push(setLocale(language_1.locale).then(function () { return setRTL(language_1.dir === 'rtl'); }));
        }
    }
    if (timeZoneHasChanged) {
        promises.push(setMailboxRegionalConfigurationPromise.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var newTimeZoneOffsetType;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getNewTimeZoneOffsets()];
                    case 1:
                        newTimeZoneOffsetType = _a.sent();
                        updateTimeZoneOffsets(newTimeZoneOffsetType);
                        return [2 /*return*/];
                }
            });
        }); }));
    }
    return promises;
};
export default getRegionalOptionsServiceRequests;
//# sourceMappingURL=getRegionalOptionsServiceRequests.js.map